import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { catchError, Observable, switchMap } from 'rxjs';
import { TokenService } from '../jwt.service'; // Importa il tuo TokenService
import { environment } from 'src/environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private tokenService: TokenService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isPharmaRequest = req.url.includes(environment.pharmaKgb);
    
   
    if (isPharmaRequest) {
      return next.handle(req);
        }
    return this.tokenService.initToken().pipe(
      switchMap(() => {
        const token = this.tokenService.getToken();
        if (token) {
          const clonedRequest = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
             "Portal-Type":'military'
            }
          });
          return next.handle(clonedRequest);
        }
        return next.handle(req);
      }),
      catchError(err => {
        console.error('Errore nel TokenInterceptor:', err);
        return next.handle(req);
      })
    );
  }
}